import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "ant-row" }
const _hoisted_2 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { style: {"font-weight":"bold"} }, "VERSÃO: ", -1)
const _hoisted_4 = {
  class: "ant-col ant-col-xs-24 ant-col-xl-24",
  style: {"text-align":"center"}
}
const _hoisted_5 = { style: {"font-size":"large","font-weight":"bold"} }
const _hoisted_6 = { class: "ant-row" }
const _hoisted_7 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_8 = { style: {"font-weight":"bolder"} }
const _hoisted_9 = { class: "ant-row" }
const _hoisted_10 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_card = _resolveComponent("card")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createTextVNode(_toDisplayString(_ctx.props.versao.nomeVersao + ' ' + _ctx.props.versao.mesVersao + '.' + _ctx.props.versao.revisao), 1)
      ])
    ]),
    _createVNode(_component_card, { titulo: "NOTAS DA VERSÃO" }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.props.versao.modulos, (modulo, indexM) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "ant-row",
            key: indexM
          }, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("span", _hoisted_5, _toDisplayString(modulo.titulo), 1)
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(modulo.notas, (nota, indexN) => {
              return (_openBlock(), _createBlock(_component_card, {
                key: indexN,
                style: {"width":"100%"}
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("span", _hoisted_8, _toDisplayString(nota.descricaoRecurso), 1)
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_9, [
                    _createElementVNode("div", _hoisted_10, [
                      _createElementVNode("span", null, _toDisplayString(nota.detalhe), 1)
                    ])
                  ])
                ]),
                _: 2
              }, 1024))
            }), 128))
          ]))
        }), 128))
      ]),
      _: 1
    })
  ], 64))
}